import { useTranslation } from 'react-i18next';
import CustomTimePicker from '../../../../../../components/CustomTimePicker';
import { CustomSelect } from '../../../../../../components/CustomSelect';
import { CustomTextField } from '../../../../../../components/CustomTextField';
import { EmailFrequency } from '../../../../../../enums/EmailFrecuency';
import DividerWithText from '../../../../../../components/DividerWithText';
import React from 'react';
import { getDaysList } from '../../../../../../utils/DaysofWeek';
import { getDaysOfCurrentMonth } from '../../../../../../Apis/functions';
import CustomUserChip from '../../../../../../components/CustomUserChip';
import {EMAIL_VALUE_VALIDATE} from './Model/Models';
import { POSITION_MODEL } from '../../../../../../Helpers/PositionModel';
import { colors } from '../../../../../../enums/colors';
import { IconInfoCard } from '../../../../../../components/buttons/IconButtons';


/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param item
 * @param setItem
 * @param onChange
 * @param emptyFields
 *
 */
const EmailSettings = (
    {
        item,
        onChange,
        emptyFields,
        disabled = false
    }
) => {

    const { t } = useTranslation();

    return (
        <>
            <DividerWithText spacing='py-1' title={t('email_reports')} />
            <div className='col-12 pb-4'>
                <CustomUserChip
                    className="m-0 chip-secondary-150-100 w-100 p-0 justify-content-start"
                    name={
                      t('report_data_filtered_by_zone_permissions')
                    }
                    showAvatar
                    iconPosition ={POSITION_MODEL.LEFT} 
                    variant="large"
                    classNameIcon="icon-color-secondary-700 ibl-font-w-500"
                    Icon={IconInfoCard}
                />
            </div>
            <div className='col-12 fs-14px font-color-shades-950 ibl-font-w-600 pb-4'>{t('delivery_schedule')}</div>
            <div className='row px-0'>
                <div className='col-12 col-sm-3 pb-4 pb-sm-0 fs-12px font-color-shades-950 ibl-font-w-400'>
                    {t('set_the_frequency_time_and_delay_for_sending_automated_attendance_reports')}
                </div>
                <div className="col-12 col-sm-9 px-0">
                    <div className="row px-0">
                        <div className='col-12 col-sm-4'>
                            <CustomSelect
                                id={'slt_es_review_frequency'}
                                name={'reviewFrequency'}
                                value={item.reviewFrequency}
                                key={item.reviewFrequency}
                                keyName='id'
                                onChange={onChange}
                                list={[
                                    { id: EmailFrequency.DAILY.value, name: t('daily') },
                                    { id: EmailFrequency.WEEKLY.value, name: t('weekly') },
                                    { id: EmailFrequency.MONTHLY.value, name: t('monthly') },
                                    { id: EmailFrequency.BIWEEKLY.value, name: t('biweekly') },
                                ]}
                                trans={'review_frequency'}
                                label={'lbl_es_review_frequency'}
                                required={true}
                                showNoSelectionOption={false}
                                emptyFields={emptyFields && !item?.reviewFrequency}
                                disabled={disabled}
                            />
                        </div>
                        <div className='col-12 col-sm-4'>
                            <CustomTimePicker
                                id='tp_es_start_time'
                                title={t('scheduled_time')}
                                name='scheduleTime'
                                value={item.scheduleTime}
                                handleChange={(value) => {
                                    onChange({ target: { value: value, name: 'scheduleTime' } });
                                }}
                                disabled={disabled}
                                formatInvalid={false}
                                required={true}
                                ampm={false}
                                emptyFields={emptyFields && !item?.scheduleTime}
                            />
                        </div>
                        <div className='col-12 col-sm-4'/>

                        {(!item?.reviewFrequency || item?.reviewFrequency === EmailFrequency.DAILY.value) &&
                            <div className='col-12 col-sm-4'>
                                <CustomTextField
                                    id='txt_es_day_after_to_send_the_email'
                                    type='number'
                                    length={2}
                                    trans='day_after_to_send_the_email'
                                    name="daysAfterSendEmail"
                                    value={item?.daysAfterSendEmail || ''}
                                    onChange={onChange}
                                    helperText='leave_0_to_avoid_send_it'
                                    suffixText={<p className={"ibl-font-w-600 text-uppercase"}>{t('days')}</p>}
                                    inputProps={{
                                        min: 1
                                    }}
                                    required={true}
                                    emptyFields={emptyFields && item?.daysAfterSendEmail === ''}
                                    disabled={disabled}
                                />
                            </div>
                        }

                        {item?.reviewFrequency === EmailFrequency.WEEKLY.value &&
                            <div className='col-12 col-sm-4'>
                                <CustomSelect
                                    id='slt_es_day_of_week'
                                    name="dayOfWeek"
                                    value={item?.dayOfWeek || ''}
                                    onChange={onChange}
                                    trans={'select_day_of_week'}
                                    list={getDaysList(t)}
                                    keyName='id'
                                    showNoSelectionOption={false}
                                    required={true}
                                    emptyFields={emptyFields && (item?.dayOfWeek === '' || Number(item.dayOfWeek) <= 0)}
                                    disabled={disabled}
                                />
                            </div>
                        }

                        {item?.reviewFrequency === EmailFrequency.MONTHLY.value &&
                            <div className='col-12 col-sm-4'>
                                <CustomSelect
                                    id='slt_es_day_of_month'
                                    name="dayOfMonth"
                                    value={item?.dayOfMonth || ''}
                                    onChange={onChange}
                                    trans={'select_day_of_month'}
                                    list={getDaysOfCurrentMonth()}
                                    keyName='id'
                                    showNoSelectionOption={false}
                                    required={true}
                                    emptyFields={emptyFields && (item?.dayOfMonth === '' || Number(item.dayOfMonth) <= 0)}
                                    disabled={disabled}
                                />
                            </div>
                        }

                        {item?.reviewFrequency === EmailFrequency.BIWEEKLY.value &&
                            <>
                                <div className='col-12 col-sm-4'>
                                    <CustomTextField
                                        id='txt_es_first_day'
                                        length={2}
                                        name="startDate"
                                        value={item?.startDate || ''}
                                        onChange={onChange}
                                        onBlur={(e) => {
                                            const value = Number(e.target.value);
                                            if (value < EMAIL_VALUE_VALIDATE.start.min || value > EMAIL_VALUE_VALIDATE.start.max) {
                                                onChange({ target: { value: '', name: 'startDate' } })
                                            }
                                        }}
                                        trans='first_day'
                                        type='number'
                                        placeholder='1 - 15'
                                        helperText={'recommended_first_day'}
                                        suffixText={<p className={"ibl-font-w-600 text-uppercase"}>{t('days')}</p>}
                                        isValidText='requiredField'
                                        inputProps={{
                                            min: EMAIL_VALUE_VALIDATE.start.min,
                                            max: EMAIL_VALUE_VALIDATE.start.max
                                        }}
                                        required={true}
                                        emptyFields={emptyFields && (item?.startDate === '' || Number(item.startDate) <= 0)}
                                        disabled={disabled}
                                    />
                                </div>
                                <div className='col-12 col-sm-4'>
                                    <CustomTextField
                                        id='txt_es_second_day'
                                        length={2}
                                        name="endDate"
                                        value={item?.endDate || ''}
                                        onChange={onChange}
                                        onBlur={(e) => {
                                            const value = Number(e.target.value);
                                            if (value < EMAIL_VALUE_VALIDATE.end.min || value > EMAIL_VALUE_VALIDATE.end.max) {
                                                onChange({ target: { value: '', name: 'endDate' } })
                                            }
                                        }}
                                        trans='second_day'
                                        type='number'
                                        placeholder='16 - 31'
                                        helperText={'recommended_second_day'}
                                        suffixText={<p className={"ibl-font-w-600 text-uppercase"}>{t('days')}</p>}
                                        isValidText='requiredField'
                                        inputProps={{
                                            min: EMAIL_VALUE_VALIDATE.end.min,
                                            max: EMAIL_VALUE_VALIDATE.end.max,
                                        }}
                                        required={true}
                                        emptyFields={emptyFields && (item?.endDate === '' || Number(item.endDate) <= 0)}
                                        disabled={disabled}
                                    />
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default EmailSettings;
